import { render, staticRenderFns } from "./funcionario.vue?vue&type=template&id=04c34714&"
import script from "./funcionario.vue?vue&type=script&lang=js&"
export * from "./funcionario.vue?vue&type=script&lang=js&"
import style0 from "./funcionario.vue?vue&type=style&index=0&id=04c34714&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports